import React from 'react';

const DoubleArrowForward = ({width= '14px', height= '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.92822 1.9999L8.81602 9.49995L1.92822 17" stroke={color || '#6E6C6C'} strokeWidth="2.50002"
                  strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M11.1113 1.9999L17.9991 9.49995L11.1113 17" stroke={color || '#6E6C6C'} strokeWidth="2.50002"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};
export default DoubleArrowForward;
